<template>
  <div data-v-f4f364e8="" data-v-2ac6a5fc="" class="modifyPhone member">
    <form data-v-f4f364e8="">
      <div data-v-f4f364e8="" class="list">
        <!---->
        <div data-v-f4f364e8="" class="form-group">
          <label data-v-f4f364e8="">手机号</label>
          <div data-v-f4f364e8="" class="input-group">
            <input data-v-f4f364e8="" :disabled="$store.state.userInfo.mobile" v-model="mobile" size="12" maxlength="12" placeholder="请输入手机号" type="text" />
          </div>
        </div>
        <div data-v-f4f364e8="" class="form-group" v-if="!$store.state.userInfo.mobile">
          <label data-v-f4f364e8="">验证码</label>
          <div data-v-f4f364e8="" class="input-group">
            <div style="width: 50%;height: 54px;float: left;">
            <input data-v-f4f364e8="" v-model="auth_code" size="12" maxlength="12" placeholder="请输入验证码" type="text"
            
            />
            </div>
            <div style="width: 50%;height: 54px;float: left;line-height: 54px;text-align: right;">
              <a v-if="num <= 0" @click="sendCode" href="javascript:void(0);" style="color: #fff; background-image: linear-gradient(224deg, #ffdf91, #ffcb4c); color: #482000; padding: 5px 8px; border-radius: 3px">发送验证码</a>
              <span v-else>{{ num }} 秒后重新发送</span>
            </div>
            <div style="clear: both;" />
          </div>
        </div>

      </div>
      <p data-v-f4f364e8="">无法修改手机号码，<a data-v-f4f364e8="" @click="$parent.openKefu">联系客服</a></p>
      <a data-v-f4f364e8="" class="form-button" @click="isOkBefor" v-if="!$store.state.userInfo.mobile">确认</a>
    </form>
  </div>
</template>
<script>
export default {
  name: 'modifyPhone',
  data() {
    return {
      mobile: null,
      auth_code: null,
      num: 0,
      timer: null,
    };
  },
  created() {
    let that = this;
    that.mobile = that.$store.state.userInfo.mobile
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    isOkBefor(){
      this.$parent.showLoading();
      this.$apiFun
        .post('/api/checkMobileCode', { mobile: this.mobile,auth_code:this.auth_code })
        .then(res => {
          this.$parent.showTost(1, res.message);
          if (res.code == 200) {
            this.isOk()
          } else {
            this.$parent.showTost(0, res.msg);
          }
          this.$parent.hideLoading();
        })
        .catch(() => {
          this.$parent.hideLoading();
        });
    },
    isOk() {
      let that = this;
      let url = '/api/bindMobile';
      let info = {};
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      info.mobile = that.mobile;
      info.auth_code = that.auth_code;
      info.birthday = userInfo.birthday;
      info.email = userInfo.email;
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(that.mobile)) {
        that.$parent.showTost(0, '请输入正确手机号');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun.post(url, info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();

        }
        if (res.code == 200) {
          that.$parent.showTost(1, res.message);
          that.$parent.getUserInfos();
        }
      });
    },
    sendCode () {
      let phonereg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-9])|(?:5[0-3,5-9])|(?:6[5-6])|(?:7[0-8])|(?:8[\d])|(?:9[1,8-9]))\d{8}$/;
      const name = this.mobile || '';
      if (phonereg.test(name) == false) {
        this.$parent.showTost(0, ' 请输入正确的手机号！');
        return;
      }

      this.$parent.showLoading();
      this.$apiFun
        .get('/api/registerNote', { mobile: name })
        .then(res => {
          this.$parent.showTost(1, res.message);
          if (res.code == 200) {
            this.num = 60;
            const that = this;
            this.$nextTick(() => {
              that.timer = setInterval(() => {
                if (that.num >= 0) that.num -= 1;
                else {
                  that.num = 0;
                  if (that.timer) clearInterval(that.timer);
                }
              }, 1000);
            });
          }
          this.$parent.hideLoading();
        })
        .catch(() => {
          this.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-f0bd1cea.3921d552.css';
</style>



// WEBPACK FOOTER //
// src/components/main/modifyPhone.vue